import script from "./changshu.vue?vue&type=script&setup=true&lang=js"
export * from "./changshu.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__